import { useContext, useState } from 'react';

import RemoveModal from '../../../../Components/Modal/RemoveModal';
import { CompetitionContext } from '../../Context/CompetitionContext';

const Ranks = ({
  ranks,
  removeRank,
  removeLoading,
  setModalIsOpen,
  modalIsOpen,
  competition,
  onChangeRank,
}) => {
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const context = useContext(CompetitionContext);
  return (
    <>
      <div className='col-12 col-md-12' style={{ marginTop: '50px' }}>
        <div className='d-flex flex-column'>
          <h1 className='text-dark f-15 font-weight-bold mx-2'>مقام ها : </h1>
          <table className='table table-hover table-striped overflow-hidden rounded-1 shadow-sm text-left'>
            {ranks?.length > 0 ? (
              <>
                <thead className='thead-persian-green text-left'>
                  <tr>
                    <th>استان</th>
                    <th>رشته</th>
                    <th>وزن</th>
                    <th>مقام</th>
                    <th>حذف</th>
                  </tr>
                </thead>
                <tbody>
                  {ranks?.map((rank, index) => (
                    <tr>
                      <td>
                        <div class='checkbox d-flex flex-row justify-conetnt-center align-items-center'>
                          <select
                            value={rank?.province_id}
                            className='form-control'
                            onChange={(e) => {
                              onChangeRank(
                                'province_id',
                                index,
                                e.target?.value,
                              );
                            }}
                          >
                            <option value={0}>انتخاب استان</option>
                            {context?.provinces?.map((province) => (
                              <option key={province?.id} value={province?.id}>
                                {province?.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </td>
                      <td>
                        <div class='checkbox d-flex flex-row justify-conetnt-center align-items-center'>
                          <select
                            value={rank?.sport_id}
                            className='form-control'
                            onChange={(e) =>
                              onChangeRank('sport_id', index, e.target?.value)
                            }
                          >
                            <option value={0}>انتخاب رشته</option>
                            {competition?.sports?.map((sport) => (
                              <option key={sport?.id} value={sport?.id}>
                                {sport?.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </td>
                      <td>
                        <div class='checkbox d-flex flex-row justify-conetnt-center align-items-center'>
                          <select
                            value={rank?.weight_id}
                            className='form-control'
                            onChange={(e) =>
                              onChangeRank('weight_id', index, e.target?.value)
                            }
                          >
                            <option value={0}>انتخاب وزن</option>
                            {competition?.weights?.map((weight) => (
                              <option key={weight?.id} value={weight?.id}>
                                {weight?.weight}
                              </option>
                            ))}
                          </select>
                        </div>
                      </td>

                      <td>
                        <div class='checkbox d-flex flex-row justify-conetnt-center align-items-center'>
                          <input
                            type='number'
                            className='form-control'
                            placeholder='لطفا مقام را بصورت عدد وارد نمایید مثال : 1'
                            value={rank?.rank}
                            onChange={(e) =>
                              onChangeRank('rank', index, e.target?.value)
                            }
                          />
                        </div>
                      </td>
                      <td>
                        <i
                          className='fal fa-trash text-danger f-18 c-pointer'
                          onClick={() => {
                            setModalRemoveObject({
                              id: rank?.id,
                              title: rank?.title,
                              index: index,
                            });
                            setModalIsOpen(true);
                          }}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </>
            ) : (
              <>
                <thead className='thead-persian-green text-left'>
                  <td></td>
                </thead>
                <tbody>
                  <tr>
                    <td className='d-flex flex-row justify-content-center'>
                      اطلاعاتی وجود ندارد
                    </td>
                  </tr>
                </tbody>
              </>
            )}
          </table>
        </div>
      </div>

      <RemoveModal
        id={modalRemoveObject}
        modalIsOpen={modalIsOpen}
        removeItem={removeRank}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف "${modalRemoveObject?.title}" مطمئن هستید ؟ درصورت حذف امکان برگشت نخواهد بود`}
      />
    </>
  );
};
export default Ranks;
